import { Component, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { PrintService } from 'src/app/core/services/print.service';
import { NotedSession, Roll } from 'src/app/shared/models/hearings/roll';

@Component({
  selector: 'app-print-rolls',
  templateUrl: './print-rolls.component.html',
  styleUrls: ['./print-rolls.component.scss']
})
export class PrintRollsComponent implements OnInit {
  rolls: Roll[] = [];
  rollNumber = 0;
  ColumnMode = ColumnMode;
  datesList;
  notedSessions: NotedSession[] = [];


  constructor(
    private printService: PrintService,
  ) {
    this.rolls = this.printService.data.rolls;
    this.rollNumber = this.printService.data.rollNumber;
    this.notedSessions = this.printService.data.notedSessions;
    this.datesList = this.getDatesList();
  }

  ngOnInit(): void {
    this.printService.onDataReady('Rolls');
  }

  getDatesList() {
    const startDate = (new Date(this.rolls[0].date)).getTime();
    const endDate = new Date(this.rolls[this.rolls.length - 1].date).getTime();
    const dateList: number[] = [];
    let d: number | null = this.rolls.length ? startDate : null;
    while (endDate >= d) {
      if (d) {
        dateList.push(d);
      }
      d += 24 * 60 * 60 * 1000  //add a day;
    }
    dateList.sort();
    let result = dateList.map(d => this.formatDate(d));
    return result;
  }

  formatDate(d: number | string) {
    return new Date(d).toLocaleDateString('ar-EG', { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' });
  }

}
